// Campus photo for /colleges/bates-college: CC BY-SA 4.0, by Odwallah, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHathorn_Hall_(extended).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/bates-college/; credited under the photo.
const photo = {
    "slug": "bates-college",
    "alt": "Hathorn Hall and its bell tower at dusk in winter snow at Bates College in Lewiston, Maine",
    "src": "/colleges/bates-college/campus-1600.webp",
    "srcSmall": "/colleges/bates-college/campus-800.webp",
    "srcMid": "/colleges/bates-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/bates-college/og.jpg",
    "title": "Hathorn Hall (extended)",
    "author": "Odwallah",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHathorn_Hall_(extended).jpg",
    "read": "2026-10-01"
};

export default photo;
